import getPaymentStatusQuery from "@api/queries/getPaymentStatus.graphql";
import type { GoPayPaymentState } from "@core/schema/GoPayPaymentState.js";
import type { GraphQLClient } from "@core/utils/aws/appsync/GraphQLClient.js";

export async function checkPaymentStatus(graphQL: GraphQLClient, gopayPaymentId: string): Promise<GoPayPaymentState> {
	const status = await graphQL.query<GoPayPaymentState, Record<"id", string>>({
		query: getPaymentStatusQuery,
		variables: { id: gopayPaymentId },
	});
	if (status === undefined) {
		throw new Error("Payment status not returned.");
	}
	return status;
}
